import React from "react";
import { MessageCircle } from "lucide-react";

function WhatsAppButton() {
  const whatsappLink = "https://wa.me/5531993018766"; // Substitua pelo seu número

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-6 bg-green-500 text-white p-4 rounded-full shadow-lg flex items-center gap-2 hover:bg-green-600 transition duration-300 z-10" // Aumentei o bottom para mais espaçamento
    >
      <MessageCircle size={24} />
      <span className="hidden sm:inline">Fale Conosco</span>
    </a>
  );
}

export default WhatsAppButton;
